export default __webpack_public_path__ + "static/media/entericon_dark.c74a0a5b.svg";